import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-attention.tsx
/**
* icon.24.attention
*
* Attention, warning, exclamation mark
*
* Keywords: alert, warning, exclamation, circle, notification, error, caution, rounded
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDVhNyA3IDAgMSAxIDAgMTQgNyA3IDAgMCAxIDAtMTRtMCAxYTYgNiAwIDEgMCAwIDEyIDYgNiAwIDAgMCAwLTEybTAgOC4wMDNhLjc1Ljc1IDAgMSAxLS4wMDEgMS41MDEuNzUuNzUgMCAwIDEgLjAwMS0xLjUwMU0xMiA4LjVjLjQyNSAwIC43Ni4zNjEuNzMuNzg1bC0uMjMxIDMuMjVhLjUuNSAwIDAgMS0uOTk4IDBsLS4yMzEtMy4yNUEuNzMzLjczMyAwIDAgMSAxMiA4LjUiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9644
*/
const Icon24Attention = memo(function Icon24Attention(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 8.003a.75.75 0 1 1-.001 1.501.75.75 0 0 1 .001-1.501M12 8.5c.425 0 .76.361.73.785l-.231 3.25a.5.5 0 0 1-.998 0l-.231-3.25A.733.733 0 0 1 12 8.5"
		})
	});
});
//#endregion
export { Icon24Attention };

//# sourceMappingURL=icon-24-attention.js.map